import { TIME_RATE_SYSTEMS } from 'src/constants/workTimeService';
export const isSummedTimeRateSystem = (timeRateSystem) => (timeRateSystem === TIME_RATE_SYSTEMS.SummaryTimeRate
    || timeRateSystem === TIME_RATE_SYSTEMS.SummedEqualWeek
    || timeRateSystem === TIME_RATE_SYSTEMS.SummedWorkWeek);
export const isDailyTimeRateSystem = (timeRateSystem) => (timeRateSystem === TIME_RATE_SYSTEMS.DailyTimeRate);
export const isAgencyTimeRateSystem = (timeRateSystem) => (timeRateSystem === TIME_RATE_SYSTEMS.AgencyAgreement);
export const isFlexibleWorkTimeRateSystem = (timeRateSystem) => (timeRateSystem === TIME_RATE_SYSTEMS.FlexibleWorkTime);
// Time rate systems whose accounting period (period start + repeat) is chosen by the user on the
// contract form. Every other system derives its accounting period from the contract start date.
export const hasSelectableAccountingPeriod = (timeRateSystem) => (isSummedTimeRateSystem(timeRateSystem)
    || isFlexibleWorkTimeRateSystem(timeRateSystem));
